import {
  getTokenFromLocalStorage,
  hasPermission,
} from "../../../helpers/helpers"
import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

const OneBet = props => {
  const dispatch = useDispatch()

  const selectRow = {
    mode: "checkbox",
  }

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [orderList, setOrderList] = useState([])
  const [isEdit, setIsEdit] = useState(false)

  const { SearchBar } = Search

  // const toggleModal = () => {
  //   setModal1(!modal1)
  // }
  const toggleViewModal = () => setModal1(!modal1)

  const EcommerceOrderColumns = [
    {
      dataField: "Id",
      text: "User Id",
      sort: true,
    },
    {
      dataField: "UserName",
      text: "User Name",
      sort: true,
    },
    {
      dataField: "LTV",
      text: "LTV",
      sort: true,
    },
    {
      dataField: "Stakes",
      text: "Stakes",
      sort: true,
    },
    {
      dataField: "Payouts",
      text: "Payouts",
      sort: true,
    },
    {
      dataField: "GGR",
      text: "GGR %",
      sort: true,
    },
  ]

  const toggle = () => {
    setModal(!modal)
  }

  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const fakeData = [
    {
      Id: 1,
      UserName: "Yaseen",
      LTV: "12",
      Stakes: "180",
      Payouts: "100",
      GGR: "40%",
    },
    {
      Id: 1,
      UserName: "Yaseen",
      LTV: "12",
      Stakes: "180",
      Payouts: "100",
      GGR: "40%",
    },
    {
      Id: 1,
      UserName: "Yaseen",
      LTV: "12",
      Stakes: "180",
      Payouts: "100",
      GGR: "40%",
    },
    {
      Id: 1,
      UserName: "Yaseen",
      LTV: "12",
      Stakes: "180",
      Payouts: "100",
      GGR: "40%",
    },
    {
      Id: 1,
      UserName: "Yaseen",
      LTV: "12",
      Stakes: "180",
      Payouts: "100",
      GGR: "40%",
    },
    {
      Id: 1,
      UserName: "Yaseen",
      LTV: "12",
      Stakes: "180",
      Payouts: "100",
      GGR: "40%",
    },
    {
      Id: 1,
      UserName: "Yaseen",
      LTV: "12",
      Stakes: "180",
      Payouts: "100",
      GGR: "40%",
    },
    {
      Id: 1,
      UserName: "Yaseen",
      LTV: "12",
      Stakes: "180",
      Payouts: "100",
      GGR: "40%",
    },
  ]

  //pagination customization
  const pageOptions = {
    sizePerPage: 6,
    totalSize: fakeData.length,
    custom: true,
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">
            {"Joined < 3 Months + 2 Dep + 2 Bets"}
          </div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={EcommerceOrderColumns}
            data={fakeData}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={fakeData}
                columns={EcommerceOrderColumns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="12">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}>
                        {hasPermission("create-deposits") && (
                          <Col sm="12">
                            <div className="text-sm-end">
                              <Button
                                type="button"
                                color="success"
                                className="btn-rounded  mb-2 me-2"
                              >
                                <i className="mdi mdi-plus me-1" />
                                Add New
                              </Button>
                            </div>
                          </Col>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default withRouter(OneBet)
